import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth, useTeam } from "@hooks";
import { useEffect } from "react";

import DropdownSelect, {
  DropdownOption,
} from "../dropdown/DropdownSelect";

export function RecordingAsSelection({
  recordingAs,
  setRecordingAs,
  showLabel = false,
}) {
  const { userUuid } = useAuth();
  const { currentTeam } = useTeam();

  const handleMemberSelectChange = (event, value) => {
    if (event === null) {
      return;
    }
    setRecordingAs(value);
  };

  useEffect(() => {
    if (
      !currentTeam?.uuid ||
      !currentTeam?.users?.length ||
      !currentTeam?.users?.filter((u) => u.uuid === recordingAs)
        .length
    ) {
      setRecordingAs(userUuid);
    }
  }, [currentTeam]);

  return (
    <div className="relative flex flex-col items-center">
      {showLabel && (
        <label
          className={`absolute -top-4 left-0 text-xs pl-1 dark:text-gray-300 text-black`}
        >
          Record As
        </label>
      )}
      <div className="absolute right-3 top-2 pointer-events-none">
        <FontAwesomeIcon icon={faChevronDown} />
      </div>
      <DropdownSelect
        value={recordingAs || userUuid}
        onChange={handleMemberSelectChange}
        dataTestId="record-as-dropdown"
      >
        {currentTeam?.users?.map((user) => (
          <DropdownOption
            key={user.uuid}
            value={user.uuid}
            dataTestId={`record-as-option-${user.uuid}`}
          >
            <span className="text-sm truncate flex justify-between items-center">
              <span>
                {user.firstName} {user.lastName}
                {user.uuid === userUuid && " (You)"}
              </span>
            </span>
          </DropdownOption>
        ))}
      </DropdownSelect>
    </div>
  );
}
